module.exports = __webpack_public_path__ + "static/media/03_3.13a0813f.png";